export const LENGTH_LIMIT = 100;
export const MENTION_PANEL_VIEWPORT_PADDING_PX = 16;
const TRIGGERS = ['@', '/'].join('');
const PUNCTUATION = '\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%\'"~=<>_:;';
const VALID_CHARS = '[^' + TRIGGERS + PUNCTUATION + '\\s]';
const VALID_JOINS = '(?:' +
    '\\.[ |$]|' + // E.g. "r. " in "Mr. Smith"
    ' |' + // E.g. " " in "Josh Duck"
    '[' +
    PUNCTUATION +
    ']|' + // E.g. "-' in "Salier-Hellendag"
    ')';
export const AtSignMentionsRegex = new RegExp('(^|\\s|\\()(' +
    '[' +
    TRIGGERS +
    ']' +
    '((?:' +
    VALID_CHARS +
    VALID_JOINS +
    '){0,' +
    LENGTH_LIMIT +
    '})' +
    ')$');
export const AtSignMentionsRegexAliasRegex = new RegExp('(^|\\s|\\()(' +
    '[' +
    TRIGGERS +
    ']' +
    '((?:' +
    VALID_CHARS +
    '){0,' +
    LENGTH_LIMIT +
    '})' +
    ')$');
export const DEFAULT_MAX_NUM_OPTIONS_PER_VARIANT = 10;
export const MAX_NUM_OPTIONS_PER_VARIANT = {
    shortcut: 5,
    device: 5,
    user: 5,
};
export const MENTION_VARIANT_ORDER = {
    device: 0,
    sources: 1,
    space: 2,
    tab: 3,
    file: 4,
    'search-mode': 5,
    skills: 6,
    shortcut: 7,
    'slash-command': 8,
    user: 9,
};
export function shouldFitMentionMenuToContent(options) {
    return options.some((option) => option.variant === 'search-mode' && option.separatorBefore);
}
export function checkForAtSignMentions(text, minMatchLength) {
    let match = AtSignMentionsRegex.exec(text);
    if (match === null) {
        match = AtSignMentionsRegexAliasRegex.exec(text);
    }
    if (match !== null) {
        // The strategy ignores leading whitespace but we need to know it's
        // length to add it to the leadOffset
        const maybeLeadingWhitespace = match[1];
        const matchingString = match[3];
        if (matchingString.length >= minMatchLength) {
            return {
                leadOffset: match.index + maybeLeadingWhitespace.length,
                matchingString,
                replaceableString: match[2],
            };
        }
    }
    return null;
}
//# sourceMappingURL=MentionsPluginShared.js.map